import React from "react";
import { getPendingSurvey } from "../../../docuclipper/api";
import { useDispatch } from "react-redux";
import { openSurvey } from "../../../redux/reducers/Survey";
type Props = {};
export const SurveyChecker: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    getPendingSurvey()
      .then((rsp) => {
        if (rsp.survey) {
          dispatch(openSurvey(rsp.survey));
        }
      })
      .catch((err) => null);
  }, []);
  return null;
};
export default SurveyChecker;
